import { map } from 'lodash';
import { DEVICE, DEVICE_ID, DEVICE_WIDTH, PERSON_ID, PERSON_WIDTH, PERSON, DEVICE_COLLECTION, PERSON_COLLECTION } from '@blade/common-ui/map-old/2d/src/config/mapConfig';
import ONLINE from '@blade/common-ui/map-old/2d/src/assets/online.png';
import OFFLINE from '@blade/common-ui/map-old/2d/src/assets/offline.png';
import UNUSUAL from '@blade/common-ui/map-old/2d/src/assets/unusual.png';
import onDuty from '@blade/common-ui/map-old/2d/src/assets/staff.png';
import staff from '@blade/common-ui/map-old/2d/src/assets/personImgs/person-staff.png';
import unstaff from '@blade/common-ui/map-old/2d/src/assets/personImgs/person-unstaff.png';
import personNormal from '@blade/common-ui/map-old/2d/src/assets/personImgs/person-normal.png';
import { creatCollectionChildId } from '@blade/common-ui/map-old/2d/src/utils/mapCollectionUtils';
const personMinorSvg = require('@blade/common-ui/map-old/2d/src/assets/personImgs/person-minor.svg');
const personMajorSvg = require('@blade/common-ui/map-old/2d/src/assets/personImgs/person-major.svg');
const personCriticleSvg = require('@blade/common-ui/map-old/2d/src/assets/personImgs/person-criticle.svg');
export const DeviceMap = {
    ONLINE,
    OFFLINE,
    UNUSUAL
};
export var heatMapColor;
(function (heatMapColor) {
    heatMapColor["CRITICAL"] = "#ED487B66";
    heatMapColor["MAJOR"] = "#F6D86F66";
    heatMapColor["MINOR"] = "#7DD18266";
    heatMapColor["NORMAL"] = "#0077FA66";
})(heatMapColor || (heatMapColor = {}));
;
export var heatMapColorTransparent;
(function (heatMapColorTransparent) {
    heatMapColorTransparent["CRITICAL"] = "#ED487B00";
    heatMapColorTransparent["MAJOR"] = "#F6D86F00";
    heatMapColorTransparent["MINOR"] = "#7DD18200";
    heatMapColorTransparent["NORMAL"] = "#0077FA00";
})(heatMapColorTransparent || (heatMapColorTransparent = {}));
;
export var PersonType;
(function (PersonType) {
    PersonType["NORMAL"] = "NORMAL";
    PersonType["MINOR"] = "MINOR";
    PersonType["MAJOR"] = "MAJOR";
    PersonType["CRITICAL"] = "CRITICAL";
    PersonType["ONLINE"] = "ONLINE";
    PersonType["OFFLINE"] = "OFFLINE";
    PersonType["BLUE"] = "BLUE";
    PersonType["STAFF"] = "STAFF";
    PersonType["UNSTAFF"] = "UNSTAFF";
})(PersonType || (PersonType = {}));
const BASE_SIZE = 2000;
// 拿到图片的url后，转化成与地图坐标系对应的宽度高度。
export async function convertMeasurement(resource) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = (_) => {
            const { height, width } = img;
            const max = Math.max(height, width);
            const ratio = BASE_SIZE / max;
            resolve({ height: ~~(height * ratio), width: ~~(width * ratio) });
        };
        img.src = resource;
        img.onerror = (_) => {
            reject(new Error());
        };
    });
}
export function generateTrackMarkData(id, vertices, mapSize, htmlDom) {
    const { x, y } = convertLocation(vertices.x, vertices.y, mapSize);
    return {
        props: {
            type: 'trackMark',
            id: 'trackMark' + id,
            name: 'trackMark',
            visible: true,
            zIndex: 3,
            static: true,
            interactive: true,
            opacity: 1,
            position: [x, y],
            htmlDom
        }
    };
}
export function generateImageData(id, status, vertices, imageSize, device, type) {
    const { x, y } = convertLocation(vertices ? vertices.x : 0, vertices ? vertices.y : 0, imageSize);
    let url = '';
    url = DeviceMap[status];
    const porpsId = creatCollectionChildId(DEVICE_COLLECTION, id);
    return {
        props: {
            ...device,
            id: porpsId,
            type: 'image',
            name: `${DEVICE}_${id}`,
            [DEVICE_ID]: id,
            device,
            visible: true,
            static: false,
            url: url,
            dataType: 'device',
            width: DEVICE_WIDTH,
            height: DEVICE_WIDTH,
            transparent: true,
            opacity: 1.0,
            position: [x, y, 3],
            zIndex: 4,
            interactive: true
        }
    };
}
// 配置对应人物的图标
export function getImgByType(type) {
    const imgs = {
        [PersonType['NORMAL']]: personNormal,
        [PersonType['MINOR']]: personMinorSvg,
        [PersonType['MAJOR']]: personMajorSvg,
        [PersonType['CRITICAL']]: personCriticleSvg,
        [PersonType['ONLINE']]: onDuty,
        [PersonType['OFFLINE']]: '',
        [PersonType['BLUE']]: '',
        [PersonType['STAFF']]: staff,
        [PersonType['UNSTAFF']]: unstaff,
    };
    return imgs[type] || onDuty;
}
;
export function generatePersonData(id, vertices, imageSize, person, details) {
    const { x, y } = convertLocation(vertices.x, vertices.y, imageSize);
    let url = '';
    // url = onDuty;
    const type = person?.type ?? 'NORMAL';
    const opacity = person?.opacity ?? 1;
    const visible = person?.visible ?? true;
    // console.log('generatePersonData persontype', type);
    url = getImgByType(type);
    const propsId = creatCollectionChildId(PERSON_COLLECTION, id);
    return {
        props: {
            id: propsId,
            type: 'image',
            name: `${PERSON}_${id}`,
            [PERSON_ID]: id,
            visible: visible,
            static: false,
            url: url,
            dataType: 'person',
            details: details,
            person,
            width: PERSON_WIDTH,
            height: PERSON_WIDTH,
            transparent: true,
            opacity: opacity,
            position: [x, y, 1],
            zIndex: 2,
            interactive: true
        }
    };
}
export function mapDevice(deviceList, size) {
    return deviceList ? map(deviceList.filter(item => item.vertices), (device) => {
        const { status, vertices, id } = device;
        return generateImageData(id, status, vertices, size, device);
    }) : [];
}
export function mapPerson(personList, size, details) {
    return personList ? map(personList.filter(item => item.vertices), (person) => {
        const { vertices, id } = person;
        return generatePersonData(id, vertices, size, person, details);
    }) : [];
}
// 图片比例坐标到地图坐标
export function convertLocation(x, y, size) {
    const { width, height } = size;
    const moveX = width * x;
    const moveY = height * y;
    return {
        x: moveX - (width >> 1),
        y: (height >> 1) - moveY
    };
}
// 地图坐标到图片比例坐标
export function reconvertLocation(mapX, mapY, size) {
    const { width, height } = size;
    return {
        x: mapX / width + 0.5,
        y: 0.5 - mapY / height
    };
}
// 计算中心点
export function getCenterPoint(component, points) {
    if (!points.length) {
        return {
            left: null, top: null
        };
    }
    const map = component.map;
    let sumX = 0;
    let sumY = 0;
    let sumZ = 0;
    points.forEach((item) => {
        sumX += item[0];
        sumY += item[1];
        sumZ += item[2];
    });
    const { x, y } = map.mapPositionToOffset(sumX / points.length, sumY / points.length);
    const mapDomRef = component.$refs.mapRef;
    const { left, top } = mapDomRef.getBoundingClientRect();
    return {
        left: left + x, top: top + y
    };
}
// 获取最右边的点
export function getRightPoint(points) {
    if (!points.length) {
        return {
            left: null, top: null
        };
    }
    let left = -Number.MAX_VALUE;
    let top = -Number.MAX_VALUE;
    points.forEach((item) => {
        if (item[0] > left) {
            left = item[0];
            top = item[1];
        }
        else if (item[0] === left && item[1] > top) {
            top = item[1];
        }
    });
    return {
        left, top
    };
}
